export default function HeroSection() {
  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20interior%20with%20warm%20amber%20spotlight%20illuminating%20red%20velvet%20curtains%2C%20film%20projector%20beam%20cutting%20through%20darkness%2C%20atmospheric%20haze%2C%20dramatic%20lighting%2C%20rich%20crimson%20and%20gold%20tones%2C%20epic%20scale%2C%20professional%20cinema%20photography&width=1800&height=900&seq=hero-bg-01&orientation=landscape"
          alt="春色影视电影主题背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-background-950/95"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/20 border border-primary-500/30 mb-6">
              <i className="ri-fire-line text-primary-400 text-sm"></i>
              <span className="text-primary-300 text-sm font-medium">最新热门电影资源库</span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-5">
              春色影视 · 电影大全高清免费在线观看
            </h1>

            <p className="text-lg md:text-xl text-background-300 font-light mb-6">
              免费不收费，不缓冲流畅播放
            </p>

            <p className="text-background-400/90 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              春色影视汇聚电影大全，涵盖动作、悬疑、喜剧、科幻、爱情等全类型高清影片及电视剧全集。每日更新最新热门电影资源库，先进CDN加速技术确保不缓冲流畅播放。无论你是动作迷、悬疑控还是追剧达人，这里都有属于你的光影世界。免费不收费，让好电影触手可及。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-500/20">
                  <i className="ri-movie-line text-accent-400"></i>
                </span>
                <div className="text-left">
                  <p className="text-accent-300 text-lg font-bold">15,000+</p>
                  <p className="text-background-500 text-xs">高清影片资源</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/20">
                  <i className="ri-user-smile-line text-primary-400"></i>
                </span>
                <div className="text-left">
                  <p className="text-primary-300 text-lg font-bold">每日更新</p>
                  <p className="text-background-500 text-xs">热门资源同步</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-500/20">
                  <i className="ri-shield-check-line text-secondary-400"></i>
                </span>
                <div className="text-left">
                  <p className="text-secondary-300 text-lg font-bold">流畅不缓冲</p>
                  <p className="text-background-500 text-xs">CDN极速加载</p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-lg bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm whitespace-nowrap transition-all duration-200 cursor-pointer no-underline"
              >
                <i className="ri-play-circle-fill text-lg"></i>
                开始观影
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-lg border border-background-300/30 hover:border-background-200/50 text-background-200 hover:text-background-50 font-medium text-sm whitespace-nowrap transition-all duration-200 cursor-pointer no-underline"
              >
                <i className="ri-trophy-line text-lg"></i>
                查看热播榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-r from-primary-500/20 via-accent-500/10 to-primary-500/20 rounded-2xl blur-2xl"></div>
              <div className="relative grid grid-cols-2 gap-3">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20featuring%20a%20lone%20figure%20in%20dark%20alley%20with%20neon%20reflections%2C%20noir%20style%2C%20dramatic%20lighting%2C%20film%20grain%2C%20professional%20poster%20design%2C%20rich%20crimson%20and%20dark%20tones&width=400&height=560&seq=hero-poster-01&orientation=portrait"
                  alt="暗夜追踪电影海报"
                  className="w-full rounded-xl object-cover aspect-[2/3] mt-6"
                />
                <div className="flex flex-col gap-3">
                  <img
                    src="https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20poster%20with%20cosmic%20nebula%20and%20time%20portal%2C%20warm%20amber%20and%20teal%20tones%2C%20cinematic%20design%2C%20epic%20scale%2C%20professional%20poster&width=400&height=270&seq=hero-poster-02&orientation=landscape"
                    alt="时光旅人电影海报"
                    className="w-full rounded-xl object-cover aspect-[3/2]"
                  />
                  <img
                    src="https://readdy.ai/api/search-image?query=Warm%20family%20drama%20movie%20poster%20with%20soft%20golden%20light%2C%20Chinese%20household%20scene%2C%20heartwarming%20atmosphere%2C%20cinematic%20poster%20design%2C%20elegant%20typography%20style&width=400&height=270&seq=hero-poster-03&orientation=landscape"
                    alt="人间烟火电影海报"
                    className="w-full rounded-xl object-cover aspect-[3/2]"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}